// Neseniai atidarytos vietos (localStorage) — paieškos ekranui.

const RAKTAS = 'neseniai_vietos'

export function getNeseniai() {
  try {
    const raw = localStorage.getItem(RAKTAS)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function pridetiNeseniai(vieta) {
  if (!vieta || !vieta.id) return
  try {
    const be = getNeseniai().filter(v => v.id !== vieta.id)
    const naujas = [vieta, ...be].slice(0, 8)
    localStorage.setItem(RAKTAS, JSON.stringify(naujas))
  } catch {
    // localStorage nepasiekiamas — praleidžiam
  }
}
